
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Line as LineChartGenerator } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import AnnotationPlugin from 'chartjs-plugin-annotation';
import ExpandedDashboardMixin from "@/views/expanded-dashboard/expanded-dashboard.mixin";
import { setGad7ChartOptions, getColor } from "@/views/expanded-dashboard/expanded-dashboard.utils";
import AssessmentResult from "@/views/dashboard/assessment-result.vue";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
  ChartDataLabels,
  AnnotationPlugin
)

@Component({
  components: {
    LineChartGenerator,
    AssessmentResult
  }
})
export default class ExpandedGad7 extends Mixins(ExpandedDashboardMixin) {
  @Prop() gad7ExpandedShow!: boolean;
  @Prop() pickDate!: Date;

  assessmentResultShow = false;
  assessmentType = "";
  assessmentDates = [];
  assessmentIds = [];
  assessmentValues = [];
  alertZones = [];
  loading = false;

  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      this.$store.dispatch("ExpandedDashboard/fetchLabels", this.pickDate),
      this.$store.dispatch("ExpandedDashboard/fetchGad7ChartOptions", this.selectedClientDDL.value),
      this.$store.dispatch("ExpandedDashboard/fetchGad7ChartData", {
        participantId: this.selectedPatientSummary.participantId, 
        clientId: this.selectedClientDDL.value,
        timezone: this.selectedClient.timezone
      })
    ];
    await Promise.all(fetch);
    setGad7ChartOptions(
        this.startDate, 
        this.labels.length,
        this.gad7AlertZones,
        this,
        this.$store
      );
  }

  getGad7Color(index: number) {
    return { color: getColor(index, this.gad7AlertZones, true) };
  }

  closeModal() {
    this.$emit('update:gad7ExpandedShow', false);
  }
}
